<script lang="ts">
  import type { Race } from '$types/races';
  import { raceTypeAbbreviation, raceTypeBadgeClass } from '$utils/race';

  export let race: Race;
</script>

<div
  class="center h-fit w-fit items-center rounded-full px-2.5 py-0.5 text-xs font-medium capitalize shadow-sm ring-1 {raceTypeBadgeClass(
    race.meeting
  )}"
>
  {raceTypeAbbreviation(race)}
</div>
